export default "__VITE_ASSET__nXgc9O$Y__"